import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'
import { useStyles } from './Styles'
import { RoleConsumer, RoleProvider } from '../../../../RoleContext'
import { FormLoader } from '../../../Loader/FormLoader'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeleteRole = ({
                      index, data, setData, count, setCount, adminSectionType, handleNotificationCall,
                      handleDeleteRoleDialog, viewDeleteRoleDialog, openDeleteRoleDialog
                    }) => {
  const classes = useStyles()

  return (
    <RoleProvider adminSectionType={adminSectionType} pageAction={'delete'} handleNotificationCall={handleNotificationCall}>
      <RoleConsumer>
        {({ deleteRoleLoading, handleDeleteRole }) => (
          <>
            {!!viewDeleteRoleDialog &&
            <Dialog
              keepMounted
              fullWidth
              maxWidth={'sm'}
              open={openDeleteRoleDialog}
              classes={{ paper: classes.NewOrderDialogPaper }}
              TransitionComponent={Transition}
              onClose={handleDeleteRoleDialog}
              aria-labelledby="BasicInfoDialog"
              aria-describedby="BasicInfoDialog"
            >
              <IconButton
                edge={false}
                className={classes.NewOrderDialogClose}
                color="inherit"
                aria-label="close dialog"
                onClick={handleDeleteRoleDialog}
              >
                <CloseIcon/>
              </IconButton>
              <DialogContent className={classes.NewOrderDialogContent}>
                {!!deleteRoleLoading && <FormLoader loading={true}/>}
                <Box px={4} pt={4} pb={1} className={classes.DeleteOrderWrapper}>
                  <WarningIcon className={classes.DeleteWarningIcon}/>
                  <p><FormattedMessage id='Role.DeleteMessage' values={{ title: data[index].name }}/></p>
                </Box>
              </DialogContent>
              <DialogActions className={classes.NewOrderDialogFooter}>
                <Button size="large" variant="contained" color="primary" className={classes.DeleteOrderBtn}
                        onClick={() => {
                          handleDeleteRole(index, data, setData,count, setCount, handleDeleteRoleDialog)
                        }}>
                  <FormattedMessage id='Page.Action.Delete'/>
                </Button>
                <Button onClick={handleDeleteRoleDialog} color="primary">
                  <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
                </Button>
              </DialogActions>
            </Dialog>
            }
          </>
        )}
      </RoleConsumer>
    </RoleProvider>
  )
}

export default DeleteRole
